import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {toast } from "react-toastify";


function AddHearingForm({ caseId: propCaseId, closeModal, onHearingAdded }) {
  const [formData, setFormData] = useState({
    caseId: propCaseId || '',  // If caseId is provided via props, use it, otherwise keep it empty
    date: '',
    reminder: false,
    notes: '',
  });

  const [cases, setCases] = useState([]);

  // Fetch available cases for dropdown
  useEffect(() => {
    if (!propCaseId) {
      const fetchCases = async () => {
        try {
          const token = localStorage.getItem("token");
          const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/projects`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          });
          setCases(res.data);
        } catch (error) {
          console.error("Error fetching cases:", error.response?.data || error);
        }
      };
      fetchCases();
    }
  }, [propCaseId]);
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    // Ensure the caseId is selected if the propCaseId is not provided
    if (!formData.caseId) {
      toast.warn("Please select a case.");
      return;
    }

    if (!formData.date) {
      toast.warn("Please provide a hearing date.");

      return;
    }

    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/hearings`, formData,  {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }); // Directly send formData
      onHearingAdded();  // Call the onHearingAdded function after successful submission
      closeModal();      // Close the modal after submission
      toast.success("hearing successfully added.");
    } catch (error) {
      console.error("Error adding hearing:", error);   
      toast.error("Failed to add hearing.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md space-y-4">
      {/* Case dropdown only if not inside CaseDetails */}
      {!propCaseId && (
        <div>
          <label className="block mb-1 font-medium">Project</label>
          <select
            name="caseId"
            value={formData.caseId}
            onChange={handleChange}
            required
            className="w-full border border-gray-300 rounded px-3 py-2"
          >
            <option value="">Select Project</option>
            {cases.map((caseItem) => (
              <option key={caseItem._id} value={caseItem._id}>
                {caseItem.caseTitle} {/* Adjust based on the case model */}
              </option>
            ))}
          </select>
        </div>
      )}

      <div>
        <label className="block mb-1 font-medium">Hearing Date</label>
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded px-3 py-2"
        />
      </div>

      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          name="reminder"
          checked={formData.reminder}
          onChange={handleChange}
        />
        <label className="font-medium">Set Reminder</label>
      </div>

      <div>
        <label className="block mb-1 font-medium">Notes</label>
        <textarea
          name="notes"
          value={formData.notes}
          onChange={handleChange}
          required

          className="w-full border border-gray-300 rounded px-3 py-2"
        />
      </div>

      <div className="flex gap-2">
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          Add Hearing
        </button>
        <button type="button" onClick={closeModal} className="bg-gray-300 px-4 py-2 rounded">
          Cancel
        </button>
      </div>
    </form>
  );
}

export default AddHearingForm;
